export default {
  defaultSensor () {
    return {
      name: '',
      value: ''
    }
  },
  defaultObject () {
    return {
      id: null,
      name: '',
      style: '',
      tpms: false,
      placardPressure: 0,
      sensorsCalculation: {
        odometer: {
          parameter: 'custom.sensor16400',
          formula: 'x'
        }
      },
      axleQuantity: 4,
      tyrePerAxle: 2,
      extremeUnderinflationWarning: 78.0,
      underinflationWarning: 85.0,
      sensors: []
    }
  },
  sensorTypes () {
    return [
      {
        value: 'SPEED',
        text: 'Speed'
      },
      {
        value: 'WEIGHT',
        text: 'weight'
      },
      {
        value: 'ODOMETER',
        text: 'Odometer'
      },
      {
        value: 'DTC',
        text: 'Current Dtc'
      },
      {
        value: 'NEXT_SERVICE',
        text: 'Next Service'
      },
      {
        value: 'BRAKE_PERFORMANCE',
        text: 'Brake Performance'
      },
      {
        value: 'DRIVER',
        text: 'Driver'
      },
      {
        value: 'FUEL',
        text: 'Fuel level'
      },
      {
        value: 'ENGINE_STATE',
        text: 'Engine state'
      }
    ]
  }
}